var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"livelo-notification",on:{"click":_vm.goToStatement}},[_c('span',[_c('i',[_c('PrataCoinSVG')],1),_vm._v(" "+_vm._s(_vm.pointsAvailableToTransfer)+"P$ ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }